<div class="crm-messages-page">
  <mat-tab-group
    [(selectedIndex)]="matTabIndex"
    (selectedIndexChange)="updateUrl($event)"
    class="crm-messages-page__tabs"
    animationDuration="0ms"
    disableRipple
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="crm-messages-page__tab-label">
          <app-icon name="icon-ipe-unread-mail"></app-icon>
          <span>{{ "CRM.messages.newMessages" | translate }}</span>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="messageTab; context: { tabIndex: 0, title: ('CRM.messages.newMessages' | translate) }"></ng-container>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="crm-messages-page__tab-label">
          <app-icon name="icon-ipe-mail-read"></app-icon>
          <span>{{ "CRM.messages.readMessages" | translate }}</span>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="messageTab; context: { tabIndex: 1, title: ('CRM.messages.readMessages' | translate) }"></ng-container>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="crm-messages-page__tab-label">
          <span>{{ "CRM.messages.myMessages" | translate }}</span>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="messageTab; context: { tabIndex: 2, title: ('CRM.messages.myMessages' | translate) }"></ng-container>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #messageTab let-tabIndex="tabIndex" let-title="title">
  <div class="crm-messages-page__section">
    <div class="crm-messages-page__toolbar">
      <div class="crm-messages-page__toolbar-copy">
        <span class="crm-messages-page__eyebrow font-walter">
          {{ 'crm.pages.crm.messages.crm.messages.messaggi' | translate }}
        </span>
        <h3 class="crm-messages-page__title">
          {{ title }}
        </h3>
      </div>
    </div>

    @if (searchForm) {
      <div class="crm-messages-page__filter-shell">
        <form class="crm-messages-filter-card" [formGroup]="searchForm">
          <div class="crm-messages-filter-card__header">
            <div class="crm-messages-filter-card__title-block">
              <span class="crm-messages-filter-card__eyebrow font-walter">
                {{ 'crm.pages.crm.messages.crm.messages.filtri' | translate }}
              </span>
              <h4 class="crm-messages-filter-card__title">
                {{ 'crm.pages.crm.messages.crm.messages.ricercaConversazioni' | translate }}
              </h4>
            </div>
          </div>

          <div class="crm-messages-filter-card__content">
            <div class="crm-messages-filter-card__group">
              <label class="crm-messages-filter-card__group-label">
                {{ 'generics.cols.lastMessageDate' | translate }}
              </label>

              <div
                class="crm-messages-filter-card__grid crm-messages-filter-card__grid--dates"
                formGroupName="lastMessageDate"
              >
                <app-input
                  [label]="'generics.cols.from' | translate"
                  formControlName="from"
                  type="date"
                ></app-input>

                <app-input
                  [label]="'generics.cols.to' | translate"
                  formControlName="to"
                  type="date"
                ></app-input>
              </div>
            </div>

            <div class="crm-messages-filter-card__grid crm-messages-filter-card__grid--filters">
              <app-input
                [label]="'generics.cols.name' | translate"
                formControlName="name"
                type="text"
              ></app-input>

              <app-input
                [label]="'generics.cols.email' | translate"
                formControlName="email"
                type="text"
              ></app-input>

              <app-input
                [label]="'generics.cols.country' | translate"
                formControlName="country"
                type="selection"
                [selectionOptions]="countrySelection"
              ></app-input>

              <app-input
                [label]="'generics.cols.assignedTo' | translate"
                formControlName="assignedTo"
                type="selection"
                [selectionOptions]="assignedToSelection"
              ></app-input>

              <app-input
                [label]="'generics.cols.lastMessageStateLabel' | translate"
                formControlName="lastMessageStateLabel"
                type="selection"
                [selectionOptions]="lastMessageStateSelection"
              ></app-input>
            </div>
          </div>

          <div class="crm-messages-filter-card__footer">
            <button
              type="button"
              class="crm-messages-filter-card__btn crm-messages-filter-card__btn--primary force-text-white"
              (click)="doSearch()"
            >
              <span>{{ 'generics.cols.search' | translate }}</span>
            </button>

            <button
              type="button"
              class="crm-messages-filter-card__btn crm-messages-filter-card__btn--secondary"
              (click)="clearFilter()"
            >
              <i class="icon-ipe-clear" aria-hidden="true"></i>
              <span>{{ 'generics.cols.clean' | translate }}</span>
            </button>
          </div>
        </form>
      </div>
    }

    @if (matTabIndex === tabIndex && actions) {
      <div class="crm-messages-page__table-shell">
        <app-tree
          [dataSource]="messages"
          [columns]="['lastMessageDate', 'name', 'email', 'country', 'assignedTo', 'lastMessageStateLabel']"
          (clickRow)="onClickRow($event)"
          [widgetOptions]="widgetOptions"
        ></app-tree>
      </div>
    }
  </div>
</ng-template>

<ng-template #messageModal>
  <app-modal-container
    [title]="'CRM.LEAD.MESSAGES' | translate"
    (closeButton)="closeMessageDialog()"
  >
    <app-email-thread
      [messageTemplates]="messageTemplates"
      [dataSource]="emailDataSource"
    ></app-email-thread>
  </app-modal-container>
</ng-template>

<ng-template
  #messageRowButton
  let-customClass="class"
  let-icon="icon"
  let-func="func"
  let-messagesToReadCount="messagesToReadCount"
  let-hideButton="hideButton"
>
  @if (!hideButton) {
    <app-button-badge
      [icon]="icon"
      [iconClass]="customClass"
      [func]="func"
      [badgeNumber]="messagesToReadCount"
    ></app-button-badge>
  }
</ng-template>
